import axiosClient from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getTopicList = createAsyncThunk(
  'helpRequest/getTopicList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`/api/help-request-topics`);
      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const submitRequest = createAsyncThunk(
  'helpRequest/submitRequest',
  async (data, { rejectWithValue }) => {
    try {
      let updatedData = data;
      const phoneNumber = data?.phone_number;

      if (!phoneNumber.startsWith('+880') && phoneNumber.length !== 0) {
        updatedData = { ...data, phone_number: '+880'.concat(phoneNumber) };
      }

      const response = await axiosClient.post(
        `/api/help-requests`,
        updatedData,
      );

      return response?.data;
    } catch (err) {
      return rejectWithValue(err?.response || err.message);
    }
  },
);
